import { useState, useEffect } from 'react'

export const useTypingAnimation = (text, speed = 50, delay = 0) => {
  const [displayedText, setDisplayedText] = useState('')

  useEffect(() => {
    let index = 0
    let timeout

    const startTyping = () => {
      timeout = setTimeout(() => {
        if (index < text.length) {
          setDisplayedText(text.substring(0, index + 1))
          index++
          startTyping()
        }
      }, speed)
    }

    const delayTimeout = setTimeout(startTyping, delay)

    return () => {
      clearTimeout(timeout)
      clearTimeout(delayTimeout)
    }
  }, [text, speed, delay])

  return displayedText
}
